<div class="platform-page-container">
  <div class="platform-header-container">
    <markant-platform-registration-header [loginButton]="false">
    </markant-platform-registration-header>
  </div>

  <div class="platform-main">
    <div class="platform-content-container">
      <div class="platform-content">
        <div class="select-content">
          <h2>{{ 'mfa.headline' | transloco }}</h2>

          <div>
            <p>{{ 'mfa.hintTextTop' | transloco }}</p>
            <p>{{ 'mfa.hintTextTop2' | transloco }}</p>
          </div>

          <div>
            <p>{{ 'mfa.selectFactor' | transloco }}</p>
          </div>

          <div class="radio-button">
            <markant-radio
              class="radio"
              [checked]="selectedMfaMethod === 'APP'"
              (checkedChange)="select('APP')"
            >
              <span class="radio-label">{{ 'mfa.app' | transloco }}</span>
            </markant-radio>
          </div>

          <div class="radio-button">
            <markant-radio
              class="radio"
              [checked]="selectedMfaMethod === 'EMAIL'"
              (checkedChange)="select('EMAIL')"
              ><span class="radio-label">{{
                'mfa.email' | transloco
              }}</span></markant-radio
            >
          </div>

          <div>
            <markant-button
              colorScheme="primary"
              [disabled]="!selectedMfaMethod"
              (click)="continueMfaSelection()"
              (keydown.enter)="continueMfaSelection()"
            >
              <span>{{ 'mfa.saveContinue' | transloco }}</span>
            </markant-button>
          </div>

          <div>
            <p>{{ 'mfa.hint' | transloco }}:</p>
            <p>{{ 'mfa.hintText' | transloco }}</p>
            <p>{{ 'mfa.hintText2' | transloco }}</p>
          </div>
        </div>
      </div>

      <div class="platform-footer">
        <markant-platform-footer [isPublic]="true"></markant-platform-footer>
      </div>
    </div>
  </div>
</div>
